import { forwardRef } from "react";

import { Box, useTheme } from "@mui/material";

import {
  BaseFormPaymentMethod,
  BaseFormPaymentMethodProps,
} from "@/forms-design-system/FormPaymentMethod/BaseFormPaymentMethod";
import { InvalidThemeErrorMessage } from "@/forms-design-system/InvalidThemeErrorMessage";
import { useTranslate } from "@/hooks/useTranslate";
import { StripeCheque } from "@/icons/external";

type ChequeFormPaymentMethodProps = Omit<BaseFormPaymentMethodProps, "icon" | "label"> & {
  customMessage?: string;
};

export const ChequeFormPaymentMethod = forwardRef<HTMLDivElement, ChequeFormPaymentMethodProps>(
  ({ customMessage, ...rest }, ref) => {
    const theme = useTheme();
    const { t } = useTranslate();

    if (!theme.palette.forms || !theme.palette.formsComponents?.paymentMethod) {
      return <InvalidThemeErrorMessage />;
    }

    return (
      <BaseFormPaymentMethod ref={ref} icon={<StripeCheque />} label={t("common", "paymentMethod.cheque")} {...rest}>
        {customMessage && (
          <Box
            padding={1.5}
            sx={{
              borderRadius: theme.radius(1),
              backgroundColor: theme.palette.formsComponents.paymentMethod.chequeCustomMessageBackgroundColor,
              border: `1px solid ${theme.palette.formsComponents.paymentMethod.chequeCustomMessageBorderColor}`,
              color: theme.palette.formsComponents.paymentMethod.chequeCustomMessageTextColor,
              whiteSpace: "pre-wrap",
            }}
          >
            {customMessage}
          </Box>
        )}
      </BaseFormPaymentMethod>
    );
  }
);

ChequeFormPaymentMethod.displayName = "ChequeFormPaymentMethod";
